import getSymbolFromCurrency from "currency-symbol-map";

import { useConfiguration } from "@src/api/configurations/use-configuration";

export function useCurrency() {
  const storeCurrencyConfig = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");
  const code = storeCurrencyConfig!.value.code || "USD";
  const symbol = getSymbolFromCurrency(
    storeCurrencyConfig!.value.code || "USD"
  );
  return { code, symbol };
}
